export default __webpack_public_path__ + "static/media/dot_news_and_announcement.479eab87.svg";